import { FunctionComponent, useContext, useEffect, useState } from "react";

import ChangelogComponent from "manifest-components/src/Changelog";
import { ChangelogType } from "manifest-components/src/Changelog/typings";
import { convertVersionStringToNumber } from "manifest-components/src/Changelog/helper";
import { VersionContext } from "../../context/Version/versionProvider";
import * as Styled from "./styles";

const hardCodedNotes: ChangelogType[] = [
  {
    date: "November 20, 2023",
    version: "1.8.455",
    changes: ["Introduce provider screen function to user who does not remember their old employer provider name"],
  },
  {
    date: "September 1, 2023",
    version: "1.8.388",
    changes: ["Introduce reallocation tools to users for our partnered employers."],
  },
  {
    date: "May 19, 2023",
    version: "1.8.374",
    changes: [
      "Update plaid connect flow to create a better user experience. User will now be redirected to Unable to connect plaid if they encounter an error.",
    ],
  },
  {
    date: "May 12, 2023",
    version: "1.8.373",
    changes: [
      "Add Henry support in step three. Henry tips are added in the last transfer step to assist user to complete user details, mailing address.",
      "Add changelog page to the app. User can access the change log for app updates.",
    ],
  },
  {
    date: "Apr 26, 2023",
    version: "1.8.358",
    changes: [
      "Introduce Henry, transfer specialist, to user. Henry tips will be populated to assist user throughout the app.",
      "Henry tips are added to first step to assist user to add their old account(s).",
      "Henry tips are added to second step to assist user to explore destination options.",
    ],
  },
  {
    date: "Feb 16, 2023",
    version: "1.8.12",
    changes: ["Introduce Henry chat function to user."],
  },
];

const Changelog: FunctionComponent = () => {
  const { currentVersion } = useContext(VersionContext);
  const [notes, setNotes] = useState<ChangelogType[]>([]);

  useEffect(() => {
    const version = currentVersion === "1.0.0" || !currentVersion ? "1.8.371" : currentVersion;
    const filteredNotes = hardCodedNotes.filter(
      (note) => convertVersionStringToNumber(note.version) <= convertVersionStringToNumber(version)
    );
    setNotes(filteredNotes);
  }, [currentVersion]);

  return (
    <Styled.ChangeLogPage>
      <ChangelogComponent notes={notes} />
    </Styled.ChangeLogPage>
  );
};

export default Changelog;
